import store from '../../../core/store';
import { backendURL } from '../../../core/utils';
import { downloadFile } from './downloader';

export const showLightbox = (images, active) => {
  return store.dispatch({
    type: 'general.lightbox/SHOW_LIGHTBOX',
    images,
    active,
  });
};

export const hideLightbox = () => {
  return store.dispatch({
    type: 'general.lightbox/HIDE_LIGHTBOX',
  });
};

export const readAttachmentAnnotations = (attachment_id) => {
  return store.dispatch({
    action: 'general.lightbox/READ_ATTACHMENT_ANNOTATION',
    method: 'GET',
    endpoint: '/attachments/' + attachment_id + '/annotations',
    has404: true,
  });
};

export const updateAttachmentAnnotation = (attachment_id, objects) => {
  return store.dispatch({
    action: 'general.lightbox/UPDATE_ATTACHMENT_ANNOTATION',
    method: 'PUT',
    endpoint: '/attachments/' + attachment_id + '/annotations',
    data: { data: objects },
  });
};

// export const exportAttachmentAnnotations = (attachment_id, formData) => {
//   return store.dispatch({
//     action: 'table.working_set_plans/EXPORT_WORKING_SET_PLAN',
//     method: 'POST',
//     endpoint: '/attachments/' + attachment_id + '/export',
//     data: formData,
//   });
// };

export const exportAttachmentAnnotations = (attachment_id, formData) => {
  return downloadFile(
    backendURL + '/attachments/' + attachment_id + '/export',
    formData,
    'POST'
  );
};

export const setPdfScale = (pdfScale) => {
  return store.dispatch({
    type: 'general.lightbox/SET_PDF_SCALE',
    pdfScale,
  });
};
